
import { useState } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import CONSTANT from '../../Constant/Constant';
import Typography from '@mui/material/Typography'
import popUpMessages from "../../config/popUpMsg.json";

function TermsConditionPopup(props) {
  
    const [open, setOpen] = useState(true)
    const [enableButton, setEnableButton] = useState(true)
    const [popMsg] = useState(popUpMessages.globalSearch)

    const handleOk = () => {
        props.termsConditionAccept(true)
        setOpen(false);
    }
    const handleCancel = () => {
        props.termsConditionCancel()
        setOpen(false);
    } 
    return (
        <Dialog
            maxWidth={'xs'}
            aria-labelledby="confirmation-dialog-title"
            open={open}
            keepMounted
            fullWidth
        >
            <DialogTitle id="confirmation-dialog-title">{popMsg[0].termsAndCondition.heading}</DialogTitle>
            <DialogContent dividers id="newhcp-text">
                <Typography gutterBottom>
                {popMsg[0].termsAndCondition.description}
                <a onClick={(e)=> setEnableButton(false)} href={CONSTANT.TERMS_LINK} target='_blank' rel="noopener noreferrer" style={{textDecoration:"none"}}>{popMsg[0].termsAndCondition.link}</a>.
                </Typography>
            </DialogContent>
            <DialogActions className='_wg-dynamic-text'>
                <Button onClick={handleOk} variant="contained" color="error" disabled={enableButton}>
                    Agree
                </Button>
                <Button onClick={handleCancel} variant="outlined" color="error">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog >
    );
}


export default TermsConditionPopup;